/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useTransactionStore = defineStore("transaction", {
    actions: {
        async getNormalFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/normal";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async getNormalCatDetailFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate,
                type: payload.type // PAWN, INTEREST, INC_PRINCIPLE, DEC_PRINCIPLE, REDEEM
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/normal/cat/detail";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async getMigrationFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/migration";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async getMigrationCatDetailFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate,
                migrationType: payload.migrationType // INTEREST, INC_PRINCIPLE, DEC_PRINCIPLE
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/migration/cat/detail";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async getOutageFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/outage";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },


        async getOutageCatDetailFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate,
                type: payload.type // PAWN, INTEREST, INC_PRINCIPLE, DEC_PRINCIPLE, REDEEM
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/outage/cat/detail";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },


        async getOutageMigrationFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/outageMigration";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },


        async getOutageMigrationCatDetailFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate,
                migrationType: payload.migrationType // INTEREST, INC_PRINCIPLE, DEC_PRINCIPLE
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/outageMigration/cat/detail";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async getLineFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/line";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },


        async getLineCatDetailFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate,
                type: payload.type // INTEREST, DEC_PRINCIPLE
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/line/cat/detail";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async getSummaryFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/summary";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },


        async getGraphDataFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/graph/data";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

    },
});